import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './styles.css';
import '../components/NewsGrid.css';
import MANGA_LIST from '../data/mangaList';
import SienBanner from '../components/SienBanner';

function MangaList() {
  return (
    <div className="manga-frame">
      <Header
        title="漫画 - ASMRキリスト教会"
        description="漫画の一覧ページです。"
        url="https://www.asmrchurch.com/manga"
        image="https://www.asmrchurch.com/static/images/i4.jpg"
      />
      <div className="news-container">
        <div className="news-header-container">
          <h1 className="news-title">漫画</h1>
        </div>
        <div style={{ color: 'var(--text)', textAlign: 'center' }}>
          <SienBanner className="manga-sien-top" />
          {MANGA_LIST.map((item) => (
            <p key={item.id} style={{ margin: '0 0 0.75em' }}>
              <a href={`/manga/${item.id}`}>
                第{item.id}話：{item.title}
              </a>
            </p>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MangaList;
